/* src/app/sidenav/sidenav.component.scss */
aside {
  position: fixed;
  width: 100%;
  max-width: 15rem;
  max-height: 100%;
  overflow: auto;
}
aside > ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
aside > ul > li {
  display: flex;
  flex-direction: row;
  margin: 8px 0 0 10px;
}
aside > ul > li > a {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-basis: 100%;
  font-weight: 500;
  text-decoration: none;
  color: rgb(94, 110, 130);
}
aside > ul > li > a > span {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  min-width: 45px;
}
aside > ul > li > a > span > i {
  font-size: 1.8rem;
}
aside > ul > li > a > i {
  color: rgb(94, 110, 130);
  margin-left: auto;
}
/*# sourceMappingURL=sidenav.component.css.map */
